import SupportEmail from './SupportEmail';

export default SupportEmail;
